import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button, Card, CardContent, Container, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { Component } from 'react'
import theme from '../../../styles/customTheme';
import investments from "../../../images/investments.png";
import { Cell, Pie, ResponsiveContainer, Label, PieChart } from 'recharts';
import Progress from "../../ui-components/graphs/Progress";
import { GradientButton } from '../GradientButton';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import StocksandEFTs from "../../ui-components/money-tab/StocksandEFTs";
import { getURLBase, updateParentHeight } from "../../../utils/helperFns";
import EditIcon from '@mui/icons-material/Edit';
import EditEnvelope from "./EditEnvelope";
import wyzrTheme from '../../../styles/customTheme';


export class InvestmentsEnvelope extends Component {
    constructor(props) {
        super(props)
        this.url = getURLBase(true) + "/envelope/investment";
        this.state = {
            showStocksandEFTs: false,
            piedata: [],
            isReady: false,
            showEditEnvelope: false,
        }
    }
    componentDidMount() {
        if (!this.state.isReady)
            this.processData({
                debit: {
                    "more to invest": this.props.envelope.target - this.props.envelope.saved,
                },
                credit: {
                    "invested so far": this.props.envelope.saved,
                }
            });
    }

    processData = (response) => {
        let textdata = response.text;
        let piedata = [];

        let d = new Map(Object.entries(response.debit));
        let c = new Map(Object.entries(response.credit));
        let total = 0;
        for (const [k, v] of d.entries()) {
            piedata.push({ name: k, value: v });
            total += v;
        }

        for (const [k, v] of c.entries()) {
            piedata.push({ name: k, value: v });
            total += v;
        }


        this.setState({
            piedata: piedata,
            textdata: textdata,
            total: total,
            isReady: true,
        });

    };

    toggleStocksandEFTs = () => {
        var show = this.state.showStocksandEFTs;
        show = !show;
        this.setState({ showStocksandEFTs: show },
            () => {
                updateParentHeight("child_InvestmentsEnvelope", "child_StocksandEFTs", this.state.showStocksandEFTs, "parent_SavingEnvelopes");
            });
    }

    toggleEditEnvelope = () => {
        this.props.envelope.icon = investments;
        var show = this.state.showEditEnvelope;
        show = !show;
        this.setState({ showEditEnvelope: show },
            () => {
                updateParentHeight("child_InvestmentsEnvelope", "child_EditEnvelope", this.state.showEditEnvelope, "parent_SavingEnvelopes");
            });
    }

    render() {
        const CenterLabel = ({ viewBox, amount = 0 }) => {
            const { cx, cy } = viewBox;
            return (
                <React.Fragment>
                    <text x={cx} y={2.2 * cy} textAnchor="middle" dominantBaseline="central" style={{ fill: wyzrTheme.palette.success.main, fontSize: "2rem", fontWeight: 700 }} >

                        {(this.props.envelope.saved / this.props.envelope.target * 100).toFixed(2)}%
                    </text>
                    <text x={cx} y={cy - 10} textAnchor="middle" dominantBaseline="central">
                        <tspan
                            style={{
                                fontWeight: 700,
                                fontSize: "2rem",
                                fontFamily: "Nunito Sans",
                            }}
                        >
                            £{amount}
                        </tspan>
                        <br />
                    </text>
                    <text x={cx} y={cy + 20} textAnchor="middle" dominantBaseline="central">
                        <tspan
                            style={{
                                fontWeight: 600,
                                fontSize: "0.9rem",
                                fontFamily: "Nunito Sans",
                            }}
                        >
                            target
                        </tspan>
                    </text>
                </React.Fragment>
            );
        };
        const COLORS = [theme.palette.grey[300], theme.palette.success.main];
        const renderCustomizedLabel = ({
            cx,
            cy,
            midAngle,
            innerRadius,
            outerRadius,
            name,
            value,
        }) => {
            const RADIAN = Math.PI / 180;
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            const fx = x > cx ? x + 20 : x - 20;
            const fy = y > cy ? y + 20 : y - 20;
            return (
                <text
                    x={fx}
                    y={fy}
                    fill="black"
                    style={{
                        fontSize: "0.9rem",
                        fontWeight: "700",
                        fontFamily: "Nunito Sans",
                    }}
                    className="recharts-text recharts-label"
                    textAnchor={fx > cx ? "start" : "end"}
                    dominantBaseline="central"
                >
                    £{value}
                    <tspan
                        x={fx}
                        y={fy + 20}
                        style={{
                            fontSize: "0.75rem",
                            fontWeight: "600",
                            display: "block",
                            fontFamily: "Nunito Sans",
                            padding: "0.6rem 1.6rem",
                            background: "linear-gradient(to right, #5DC68E, #4AAC48)"
                        }}
                    >
                        {name}
                    </tspan>
                </text>
            );
        };

        return (
            <Card className="popup" id="child_InvestmentsEnvelope">
                <Box className="popupClose">
                    <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
                        <ArrowBack />
                    </IconButton>
                </Box>

                <Box display={{ xs: "none", sm: "block" }} position="absolute" top={0} right={0} p={2} zIndex={20}>
                    <Button variant="outlined" size="small" onClick={this.toggleEditEnvelope} startIcon={<EditIcon />}>
                        Edit Goal
                    </Button>
                </Box>

                <Box className="popupHeader" pb={2}>
                    <img src={investments} width={40} height={40} alt="" style={{ display: "block", margin: "auto" }} />
                    <Typography gutterBottom align="center" variant="h4" sx={{ display: "block", margin: "auto", marginBottom: { xs: 0, sm: 2 } }}>
                        Investments Envelope
                    </Typography>
                    <Divider light />
                </Box>
                <Box className="popupBody" pt={{ xs: 12, sm: 0 }}>

                    <Box display={{ xs: "block", sm: "none" }} textAlign="center" mt={2}>
                        <Button variant="outlined" size="small" onClick={this.toggleEditEnvelope} startIcon={<EditIcon />}>
                            Edit Goal
                        </Button>
                    </Box>

                    <CardContent mt={3}>
                        <Grid container columnSpacing={6} className="paddingContainer">
                            <Grid item sm={12} md={5}>
                                <Box className="flex-center-all" sx={{ flexDirection: "column" }}>
                                    <Typography gutterBottom align="center" variant="h5">
                                        Let's make your savings work for you
                                    </Typography>
                                    <Typography gutterBottom align="center" variant="body2" color="text.secondary">
                                        Suggested amount put aside for investing based on your past data. If that is absent we use national averages.
                                    </Typography>
                                </Box>
                                <Box>
                                    <Container className="chartContainer" >
                                        <ResponsiveContainer>
                                            <PieChart>
                                                <Pie
                                                    data={this.state.piedata}
                                                    label={renderCustomizedLabel}
                                                    labelLine={false}
                                                    outerRadius="100%"
                                                    innerRadius="80%"
                                                    fill="#8884d8"
                                                    paddingAngle={0}
                                                    dataKey="value"
                                                    verticalAlign="center"
                                                    startAngle={325}
                                                    endAngle={-35}
                                                >
                                                    <Label
                                                        content={<CenterLabel amount={this.state.total} />}
                                                        position="center"
                                                    />
                                                    {this.state.piedata.map((entry, index) => (
                                                        <Cell fill={COLORS[index % COLORS.length]} />
                                                    ))}
                                                </Pie>
                                                <Tooltip />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </Container>

                                </Box>
                                <Box sx={{ marginTop: "3rem" }}>
                                    <Progress
                                        sx={{ margintop: 6 }}
                                        width="100%"
                                        prefix={' '}
                                        startText="months gone"
                                        endText="months to go"
                                        startNumber={8}
                                        endNumber={2}
                                        color={theme.palette.primary.light}
                                    />
                                </Box>
                                <Grid container justifyContent="space-around" marginTop={3}>
                                    <Grid item xs={5}>
                                        <GradientButton fullWidth sx={{ borderRadius: "0.7rem !important", textTransform: "capitalize" }}>
                                            Deposit
                                        </GradientButton>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Button fullWidth variant="outlined" color="error" sx={{ borderRadius: "0.7rem" }}>
                                            Withdraw
                                        </Button>
                                    </Grid>
                                </Grid>


                            </Grid>
                            <Grid item md={1} display={{ xs: "none", md: "block" }}>
                                <Divider orientation="vertical" light
                                />
                            </Grid>
                            <Grid item md={6} sm={12} mt={{ xs: 4, md: 0 }} width="100%">
                                <Typography gutterBottom align="center" variant="h6">
                                    Invest
                                </Typography>
                                <Grid
                                    container
                                    justifyContent="center"
                                >
                                    <Grid
                                        item
                                        xs={8}
                                        sm={6}
                                        margin="auto"
                                    >
                                        <Stack rowGap={3}>
                                            <Button variant="text" sx={{ width: "100%", padding: 0 }}
                                                onClick={() => {
                                                    this.toggleStocksandEFTs()
                                                }}>
                                                <Box
                                                    p={3}
                                                    className="flex-center-all"
                                                    sx={{ width: "100%", height: 100, borderRadius: 2, backgroundColor: theme.palette.primary.light }} boxShadow={3}
                                                >
                                                    <Typography
                                                        variant="h6"
                                                        marginBottom={0}
                                                        align="center"
                                                        gutterBottom
                                                    >
                                                        Stocks & ETFs
                                                    </Typography>
                                                </Box>
                                            </Button>

                                            <Button variant="text" sx={{ width: "100%", padding: 0 }} >
                                                <Box
                                                    className="flex-center-all"
                                                    p={3}
                                                    sx={{ width: "100%", height: 100, borderRadius: 2, backgroundColor: theme.palette.primary.light }} boxShadow={3}
                                                >
                                                    <Typography
                                                        variant="h6"
                                                        marginBottom={0}
                                                        align="center"
                                                        gutterBottom
                                                    >
                                                        Funds
                                                    </Typography>
                                                </Box>
                                            </Button>


                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>


                    </CardContent>
                </Box>
                {
                    this.state.showStocksandEFTs ?
                        <StocksandEFTs
                            grandparentExist={true}
                            toggleHandler={this.toggleStocksandEFTs} />
                        : null
                }

                {this.state.showEditEnvelope ?
                    <EditEnvelope
                        envelope={this.props.envelope}
                        parent="child_InvestmentsEnvelope"
                        toggleHandler={this.toggleEditEnvelope} />
                    : null
                }
            </Card>
        )
    }
}

export default InvestmentsEnvelope
